import React from 'react';
import { styles } from './GenericTab.css';
import { LocationIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Location';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner';
import Button from '@jbhi-fi/lanyard-ui/components/Button';

export interface GenericTabProps {
  isFetch?: boolean;
  handleFetchClick: () => void;
  isLoading?: boolean;
  isError?: boolean;
  children?: JSX.Element;
  isDelivery: boolean;
}

export const GenericTab = ({ isFetch, handleFetchClick, isLoading, children }: GenericTabProps) => {
  if (isFetch)
    return (
      <div className={styles.fetchTab}>
        <Button
          type="secondary"
          label="Check availability"
          onClick={() => handleFetchClick()}
          icon={<LocationIcon />}
          iconPosition="left"
          data-testid="fulfillment-tab-check-availability-button"
        />
      </div>
    );
  if (isLoading)
    return (
      <div className={styles.loadingTab} data-testid="fulfillment-tab-spinner">
        <Spinner />
      </div>
    );
  if (children) return children;
  return null;
};
